function initializeSearch() {
    var searchMode = $('[name="Search.SearchMode"]:checked').val();

    var model = new Backbone.Model();

    window.searchView = new SearchView(model, {
        disableTypeahead: searchMode === "FULLTEXT_SEARCH"
    });
    searchView.setTextTransformer(ym.util.formatAddressLine);

    $('[name="Search.SearchMode"]').change(function () {
        var value = $('[name="Search.SearchMode"]:checked').val();

        if ('POI_SEARCH' === value) {
            searchView.enableTypeahead();
        } else {
            searchView.disableTypeahead();
        }
    });

    searchView.render();

    $("#Search_SingleSlotGeo").popover('show');
    setTimeout(function() {
        $("#Search_SingleSlotGeo").popover('hide');
    }, 5000);
}

ym.ready({ autocomplete: 5 }, function () {
    if (!ym.modules.autoComplete && sm.autocomplete.v5) {
        ym.modules.autoComplete = sm.autocomplete.v5.autoComplete;
    }
    initializeSearch();
});